"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificateUtils = exports.HttpStatus = void 0;

var tslib_1 = require("tslib");

var Parameters_1 = require("../components/Control/Parameters");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var NotariusClient_1 = require("./NotariusClient");

var HttpStatus;

(function (HttpStatus) {
  HttpStatus["NetworkError"] = "NetworkError";
})(HttpStatus = exports.HttpStatus || (exports.HttpStatus = {}));

var CertificateUtils =
/** @class */
function () {
  function CertificateUtils(options) {
    var _a = options || {},
        _b = _a.sid,
        sid = _b === void 0 ? '' : _b,
        _c = _a.env,
        env = _c === void 0 ? Parameters_1.Env.Prod : _c,
        _d = _a.plugin,
        plugin = _d === void 0 ? new Plugin_1.Plugin() : _d;

    this.ntrClient = new NotariusClient_1.NotariusClient({
      sid: sid,
      env: env
    });
    this.plugin = plugin;
  }
  /**
   * Проверка доступа пользователя к закрытому ключу железного сертификата
   * @param {ICertificate} certificate
   * @throws {IError} error. error.code: DecryptErrors | WSErrorStatus | undefined
   * import { DecryptErrors, WSErrorStatus } from 'certificates-list/lib/CertificateUtils'
   */


  CertificateUtils.prototype.checkIronPKAccess = function (certificate) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var encryptedToken, decryptedToken;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.ntrClient.privateKeyCheck(certificate.toBase64())];

          case 1:
            encryptedToken = _a.sent();
            return [4
            /*yield*/
            , this.plugin.decrypt({
              type: 'base64',
              data: encryptedToken
            }, {
              type: 'base64'
            })];

          case 2:
            decryptedToken = _a.sent();
            return [4
            /*yield*/
            , this.ntrClient.privateKeyApprove(certificate.thumbprint(), decryptedToken.data)];

          case 3:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Проверка доступа пользователя к закрытому ключу облачного сертификата
   * @param {ICertificate} certificate
   */


  CertificateUtils.prototype.checkCloudPKAccess = function (certificate) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        throw new Error('Not implemented');
      });
    });
  };

  return CertificateUtils;
}();

exports.CertificateUtils = CertificateUtils;